import {defineMessages} from 'react-intl';

export default defineMessages({
	yes: {
		id: 'forms.fields.yes',
		defaultMessage: 'Yes',
	},
	no: {
		id: 'forms.fields.no',
		defaultMessage: 'No',
	},
});
